import axios from '@/axiosr8'
import moment from 'moment'

class PointAlarmsPrototypeProvider {
  async getAlgorithms (token) {
    let result = await axios.get('possonline/alarms/points/' + 'algorithms', {
      headers: {
        'asset-token': token
      }
    })
    return result.data
  }

  async getAssetWithAlgorithms (asset, languageCode, token) {
    let result = await axios.get('possonline/alarms/points/' + btoa(asset.UniqueId) + `/assetwithalgorithms?languageCode=${languageCode}`, {
      headers: {
        'asset-token': token
      }
    })
    return result.data
  }

  async getAvailableAlgorithms (asset, languageCode, token) {
    let result = await axios.get('possonline/alarms/points/' + btoa(asset.UniqueId) + `/availablealgorithms?languageCode=${languageCode}`, {
      headers: {
        'asset-token': token
      }
    })
    return result.data
  }

  async removeAlgorithm (asset, token, algorithmId) {
    let result = await axios.delete('possonline/alarms/points/' + btoa(asset.UniqueId) + '/assetalgorithms/algorithm/' + algorithmId, {
      headers: {
        'asset-token': token
      }
    })
    return result.data
  }

  async updateStartDate (asset, token, startDate) {
    const date = new Date(startDate)
    let result = await axios.put('possonline/alarms/points/' + btoa(asset.UniqueId) + '/assetalgorithms/updatestartdate', date, {
      headers: {
        'Content-Type': 'application/json',
        'asset-token': token
      }
    })
    return result.data
  }

  async previewBackgroundWorker (asset, token, algorithmSetting, startDate, sectionType) {
    const formattedDate = moment(startDate).format('YYYYMMDD')
    const result = await axios.post(
      'possonline/alarms/points/' + btoa(asset.UniqueId) + `/assetalgorithms/previewbackgroundworker?startDate=${formattedDate}&sectionType=${sectionType}`,
        algorithmSetting, {
          headers: {
            'asset-token': token
          }
        }
      )
    return result.data
  }

  async getAlgorithmParameters (algorithm, token) {
    let result = await axios.get('possonline/alarms/points/' + `algorithms/${algorithm.name}`, {
      headers: {
        'asset-token': token
      }
    })
    return result.data
  }

  async getAlgorithmParametersById (algorithm, token) {
    let result = await axios.get('possonline/alarms/points/' + `algorithms/id/${algorithm.id}`, {
      headers: {
        'asset-token': token
      }
    })
    return result.data
  }

  async getHealthScore (asset, token, from, to, direction, days) {
    let result = await axios.get('possonline/alarms/points/' + btoa(asset.UniqueId) + '/trends', { params: {
      dtFrom: from,
      dtTo: to,
      direction: direction,
      days: days
    }}, {
      headers: {
        'asset-token': token
      }
    })
    return result.data
  }

  async createAlgorithmSetting (asset, token, algorithmSetting) {
    const { direction, algorithmId, sectionTypes } = algorithmSetting

    const url = `possonline/alarms/points/${btoa(asset.UniqueId)}/assetalgorithms` +
                `?direction=${direction}&algorithmId=${algorithmId}`

    // Send sectionTypes directly as the body
    let result = await axios.post(url, sectionTypes, {
      headers: {
        'asset-token': token
      }
    })

    return result.data
  }

  async updateAlgorithmSections (asset, token, algorithmSetting) {
    const { assetAlgorithmId, sectionTypes } = algorithmSetting

    const url = `possonline/alarms/points/${btoa(asset.UniqueId)}/assetalgorithms/updatesections` +
                `?assetAlgorithmId=${assetAlgorithmId}`

    // Send sectionTypes directly as the body
    let result = await axios.put(url, sectionTypes, {
      headers: {
        'asset-token': token
      }
    })

    return result.data
  }

  async updateSections (asset, token, sections) {
    let result = await axios.put('possonline/alarms/points/' + btoa(asset.UniqueId) + '/sections', sections, {
      headers: {
        'asset-token': token
      }
    })
    return result.data
  }

  async updateAlgorithmSetting (asset, token, algorithmSetting) {
    let result = await axios.put('possonline/alarms/points/' + btoa(asset.UniqueId) + '/assetalgorithms/' + algorithmSetting.id, algorithmSetting, {
      headers: {
        'asset-token': token
      }
    })
    return result.data
  }

  async removeAlgorithmSetting (asset, token, id) {
    let result = await axios.delete('possonline/alarms/points/' + btoa(asset.UniqueId) + '/algorithmsettings/' + id, {
      headers: {
        'asset-token': token
      }
    })
    return result.data
  }

  async getUser () {
    let result = await axios.get('possonline/alarms/points/getuser')

    return result.data
  }

  async getAvailablesections (asset, token, languageCode) {
    let result = await axios.get('possonline/alarms/points/' + btoa(asset.UniqueId) + `/availablesections?languagecode=${languageCode}`, {
      headers: {
        'asset-token': token
      }
    })
    return result.data
  }

  async getSections (asset, token) {
    let result = await axios.get('possonline/alarms/points/' + btoa(asset.UniqueId) + '/sections', {
      headers: {
        'asset-token': token
      }
    })
    return result.data
  }

  async createSections (asset, token, sections, direction) {
    let result = await axios.post('possonline/alarms/points/' + btoa(asset.UniqueId) + '/sections?direction=' + direction, sections, {
      headers: {
        'asset-token': token
      }
    })
    return result.data
  }

  async getSectionsByDirection (asset, token, direction) {
    let result = await axios.get('possonline/alarms/points/' + btoa(asset.UniqueId) + '/sections?direction=' + direction, {
      headers: {
        'asset-token': token
      }
    })
    return result.data
  }

  async getSingleReferenceCurve (asset, token, direction) {
    let result = await axios.get('possonline/alarms/points/' + btoa(asset.UniqueId) + '/referencecurves/singleset?direction=' + direction, {
      headers: {
        'asset-token': token
      }
    })
    return result.data
  }
}

export default new PointAlarmsPrototypeProvider()



// WEBPACK FOOTER //
// ./src/providers/PointAlarmsPrototypeProvider.js